import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { StyledBadge } from "./Badge.styles";
export var Badge = function(param) {
    var content = param.content, _rules = param.rules, badgeRules = _rules.badge, verticalSpacing = _rules.verticalSpacing;
    var ref = badgeRules || {}, _shouldHide = ref.shouldHide, shouldHide = _shouldHide === void 0 ? false : _shouldHide, _style = ref.style, style = _style === void 0 ? "default" : _style;
    if (shouldHide) {
        return null;
    }
    return /*#__PURE__*/ _jsx(StyledBadge, {
        text: content === null || content === void 0 ? void 0 : content.text,
        type: style,
        isLargeAtMD: verticalSpacing === null || verticalSpacing === void 0 ? void 0 : verticalSpacing.isLargeAtMD
    });
};
